import React, { useState, useEffect } from "react";
import API from "../axios";
import { motion } from "framer-motion";
import dAward from "../assets/awardDefault.png"; // ✅ FIXED
import "../App.css";

const Awards = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAwards = async () => {
    try {
      setLoading(true);
      const res = await API.get("/awards");
      setData(res.data);
      console.log(res.data);
    } catch (err) {
      console.error("Error fetching awards", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAwards();
  }, []);

  const cardVariant = {
    hidden: { opacity: 0, y: 60 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8 }
    }
  };

  return (
    <div className="container mt-3 mb-5 mb-lg-0 pt-lg-3">
      <h3 className="text-center mb-lg-5 mb-3 career-title" style={{color:"#2B7CD3"}}>Awards</h3>

      {loading ? (
        <div className="text-center">Loading...</div>
      ) : data.length === 0 ? (
        <div className="text-center text-danger">No Awards Found</div>
      ) : (
        <div className="row g-4">
          {data.map((item, index) => {
            const imageSrc = item.imageBase
              ? `data:image/png;base64,${item.imageBase}`
              : dAward;

            return (
              <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={item.id}>
                <motion.div
                  className="card award-card shadow-sm"
                  variants={cardVariant}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.2 }}
                  whileHover={{ scale: 1.03 }}
                >
                  <motion.img
                    src={imageSrc}
                    alt="award"
                    className="card-img-top award-img"
                    onError={(e) => (e.target.src = dAward)}
                    
                    // 🔥 3D hover effect
                    whileHover={{
                      rotateX: 12,
                      scale: 1.05
                    }}
                    transition={{ type: "spring", stiffness: 200 }}
                  />

                  <div className="card-body text-center">
                    <h6 className="fw-bold mb-2">{item.title}</h6>
                    <p className="text-muted small mb-0">
                      {new Date(item.awardDate).toLocaleDateString()}
                    </p>
                  </div>
                </motion.div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Awards;